module.exports = __webpack_public_path__ + "h5/img/cygn3.bfc521b6.png";